import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function usePresenceUtils() {
    var _a = React.useState(), presenceElement = _a[0], setPresenceElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || presenceElement)
            return;
        var loadedPresenceElement = client.getPresenceElement();
        setPresenceElement(loadedPresenceElement);
    }, [client, setPresenceElement, presenceElement]);
    return presenceElement;
}
export function usePresenceUsers() {
    var presenceElement = usePresenceUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!presenceElement)
            return;
        var subscription = presenceElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [presenceElement]);
    return data;
}
